import React from 'react';
import {Outlet} from 'react-router-dom';

// Simplified from LC2's MinimalLayout (drops the BrowserView/MobileView split for now —
// revisit once the new UI's responsive behavior is defined by Figma).
const MinimalLayout = () => <Outlet />;

export default MinimalLayout;
